export default "__VITE_ASSET__r_kbN49___"